import * as React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import DrawerComponent from "../../components/DrawerComponent/DrawerComponent";
import AppBarComponent from "../../components/AppBarComponent/AppBarComponent";
import TablaProyectos from "../../components/Proyectos/TablaProyectos";

export default function ProyectosPage() {
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleDrawerOpen = () => setOpen((prev) => !prev);
  const handleDrawerClose = () => setOpen(false);

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <CssBaseline />
      <AppBarComponent
        open={open}
        handleDrawerOpen={handleDrawerOpen}
        auth={true}
        anchorEl={anchorEl}
        handleMenu={handleMenu}
        handleClose={handleClose}
        title="Gestion de Proyectos"
      />
      <DrawerComponent open={open} handleDrawerClose={handleDrawerClose} />
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto", pt: "116px", pb: "56px" }}>
        <Container maxWidth="xl" sx={{ mt: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TablaProyectos />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}
